// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"11e85e94","732":"f604059c","977":"65d55008"}[chunkId] + ".chunk.js";
};